import * as React from 'react';
import styled from 'styled-components';

import { deviceBreakpoints } from '../../hooks/useDeviceQuery.hook';
import { colorsV2 } from '../colors-v2';

export const BoxDefaultPadding = {
  mobile: 16,
  desktop: 16,
} as const;

export interface BoxProps
  extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLElement>, HTMLElement> {
  padding?: string;
  margin?: string;
  background?: string;
}

export interface BoxContainerProps extends BoxProps {}
export interface BoxHeaderProps extends BoxProps {}
export interface BoxContentProps extends BoxProps {}

const MAIN_BOX_STYLE = `
  background: ${colorsV2.white100};
   @media ${deviceBreakpoints.allExceptMobile} {
    border-radius: 16px;
  }
`;

const BoxContainer = styled.section.withConfig({
  componentId: 'Box_BoxContainer',
} as any)<BoxContainerProps>`
  ${MAIN_BOX_STYLE}
  padding: ${(p) => p.padding || 0};
  overflow: hidden;
`;

const BoxHeader = styled.header.withConfig({
  componentId: 'Box_BoxHeader',
} as any)<BoxHeaderProps>`
  padding: ${(p) => p.padding || '16px'};
  box-shadow: inset 0 -1px 0 ${colorsV2.gray10};
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  background: ${(p) => p.background || 'transparent'};
`;

const BoxContent = styled.article.withConfig({
  componentId: 'Box_BoxContent',
} as any)<BoxContentProps>`
  padding: ${(p) => p.padding || '16px'};
  background: ${(p) => p.background || 'transparent'};
`;

const BoxFooter = styled.footer.withConfig({
  componentId: 'Box_BoxFooter',
} as any)<BoxHeaderProps>`
  padding: ${(p) => p.padding || '16px'};
  background: ${(p) => p.background || 'transparent'};
  box-shadow: inset 0 1px 0 ${colorsV2.gray10};
`;

export const LayoutBox = {
  Container: BoxContainer,
  Header: BoxHeader,
  Content: BoxContent,
  Footer: BoxFooter,
};

export const Box = styled.section.withConfig({
  componentId: 'Box_Box',
} as any)<BoxProps>`
  ${MAIN_BOX_STYLE}

  padding: ${(p) => p.padding || `${BoxDefaultPadding.mobile}px`};

  margin: ${(p) => p.margin};

  @media ${deviceBreakpoints.desktop} {
    padding: ${(p) => p.padding || `${BoxDefaultPadding.desktop}px`};
  }
`;
